"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NebraskaSizes = void 0;
var Border;
(function (Border) {
    Border["x400"] = "var(--size-border-x400)";
    Border["x500"] = "var(--size-border-x500)";
    Border["x600"] = "var(--size-border-x600)";
})(Border || (Border = {}));
var Radius;
(function (Radius) {
    Radius["max"] = "var(--size-radius-max)";
    Radius["x100"] = "var(--size-radius-x100)";
    Radius["x200"] = "var(--size-radius-x200)";
    Radius["x300"] = "var(--size-radius-x300)";
    Radius["x400"] = "var(--size-radius-x400)";
})(Radius || (Radius = {}));
var Spacing;
(function (Spacing) {
    Spacing["x1000"] = "var(--size-spacing-x1000)";
    Spacing["x1100"] = "var(--size-spacing-x1100)";
    Spacing["x1200"] = "var(--size-spacing-x1200)";
    Spacing["x1400"] = "var(--size-spacing-x1400)";
    Spacing["x150"] = "var(--size-spacing-x150)";
    Spacing["x1800"] = "var(--size-spacing-x1800)";
    Spacing["x2000"] = "var(--size-spacing-x2000)";
    Spacing["x300"] = "var(--size-spacing-x300)";
    Spacing["x350"] = "var(--size-spacing-x350)";
    Spacing["x400"] = "var(--size-spacing-x400)";
    Spacing["x450"] = "var(--size-spacing-x450)";
    Spacing["x500"] = "var(--size-spacing-x500)";
    Spacing["x600"] = "var(--size-spacing-x600)";
    Spacing["x700"] = "var(--size-spacing-x700)";
    Spacing["x75"] = "var(--size-spacing-x75)";
    Spacing["x800"] = "var(--size-spacing-x800)";
    Spacing["x900"] = "var(--size-spacing-x900)";
})(Spacing || (Spacing = {}));
exports.NebraskaSizes = {
    Border: Border,
    Radius: Radius,
    Spacing: Spacing
};
